import { Button, ButtonColor } from "@swivl-mono/ui";

import ModalModel from "../../Models/Modal/Modal.Model";

interface SwitchOrgModalProps {
  orgName: string;
  /** e.g. "This ticket" / "This conversation" — keeps the copy generic across callers. */
  resourceLabel: string;
  onSwitch: () => void;
}

// Shown when a logged-in Member belongs to the resource's org, elsewhere.
export function SwitchOrgModal({ orgName, resourceLabel, onSwitch }: SwitchOrgModalProps) {
  return (
    <div className="flex w-[420px] flex-col items-center gap-4 py-2 text-center">
      <h2 className="heading-base-alt text-black">
        {resourceLabel} belongs to {orgName}
      </h2>
      <span className="body-sm text-grey-600">Switch to {orgName} for full access, or stay here if you just need to view the content.</span>
      <div className="flex gap-2">
        <Button color={ButtonColor.BLACK} onClick={() => ModalModel.hideModal()}>
          Stay Here
        </Button>
        <Button color={ButtonColor.ORANGE} onClick={onSwitch}>
          Switch to {orgName}
        </Button>
      </div>
    </div>
  );
}
